export default __webpack_public_path__ + "static/media/logo2.decf1b50.svg";